import { KpiSetElement } from 'shared/report-template/report-template-adapter/model/kpi-set-element.model';
import { ScatterPlotChartElement } from 'shared/report-template/report-template-adapter/model/scatter-plot-element.model';

import { ConsumptionTableElement } from './consumption-table-element.model';
import { HeaderElement } from './header-element.model';
import { LineChartElement } from './linechart-element.model';
import { TableElement } from './table-element.model';

export interface ReportTemplate {
    id: string;
    sections: TemplateSection[];
    creationDate: Date;
}

export interface TemplateSection {
    id: string;
    sortId: number;
    title: string;
    elements: TemplateElement[];
}

export type TemplateElement =
    | TableElement
    | ConsumptionTableElement
    | LineChartElement
    | ScatterPlotChartElement
    | KpiSetElement
    | HeaderElement;

export interface Base {
    id: string;
    title: string;
    type: ElementType;
}

export enum ElementType {
    Header,
    Table,
    LineChart,
    ScatterPlot,
    KpiSet,
    ConsumptionTable,
}

export interface ElementItem {
    icon: string;
    type: ElementType;
    label: string;
}
